// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"30f39ad6","603":"822c2a3e","978":"151f9ca6"}[chunkId] + ".chunk.js";
};